import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import MemberPanel from "@/pages/MemberPanel";
import AdminPanel from "@/pages/AdminPanel";
import AppShell from "@/components/AppShell";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { InvitationViewerProvider } from "@/contexts/InvitationViewerContext";

function App() {
  return (
    <div className="App min-h-screen">
      <SettingsProvider>
        <InvitationViewerProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<AppShell />}>
                <Route path="/" element={<Navigate to="/uye" replace />} />
                <Route path="/uye" element={<MemberPanel />} />
                <Route path="/yonetici" element={<AdminPanel />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
        </InvitationViewerProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
